
import vue from 'vue'
import Toast from 'vux/src/components/toast/index.vue'
import Picker from 'vux/src/components/picker/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Box from 'vux/src/components/box/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Radio from 'vux/src/components/radio/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'

import {
initWxJSSDK,
loadMapMarkerTerminals,
getTerminalDetail,
openDoor,
getOpenDoorStatus,
finishWorkOrder
} from '../../common/js/api.js'
import { getCookie, setCookie, removeCookie } from '../../common/js/utils.js'
import { TMap } from '../../common/js/map.js'

export default {
directives: {
TransferDom
},
components: {
Toast,
Picker,
PopupPicker,
XHeader,
Box,
XButton,
XInput,
Group,
CellBox,
Cell,
Scroller,
Icon,
Search,
Flexbox,
FlexboxItem,
TransferDom,
Radio,
Popup,
Grid,
GridItem,
GroupTitle
},
methods: {
init() {
let self = this
if (self.isInit) {
return
}
if (!self.myLocation) {
return
}
let directionsService = new qq.maps.DrivingService({
complete: function(response) {
let directions_routes = response.detail.routes
let route = directions_routes[0]
let polyline = new qq.maps.Polyline({
path: route.path,
strokeColor: '#3893F9',
strokeWeight: 3,
map: self.map
})
self.map.fitBounds(response.detail.bounds)
}
})
self.directionsServiceList.push(self.directionsService)
directionsService.setPolicy(qq.maps.DrivingPolicy['LEAST_TIME'])
directionsService.search(
new qq.maps.LatLng(self.myLocation.latitude, self.myLocation.longitude),
new qq.maps.LatLng(
self.currentTerminal.latitude,
self.currentTerminal.longitude
)
)

self.terminals.push({
gps: new qq.maps.LatLng(
self.currentTerminal.latitude,
self.currentTerminal.longitude
),
location: self.currentTerminal.location,
status: self.currentTerminal.status,
online: self.currentTerminal.extInfo.online,
useAll: self.currentTerminal.useAll,
terminalId: self.currentTerminal.sid,
terminalCode: self.currentTerminal.terminalId,
organId: self.currentTerminal.organId
? self.currentTerminal.organId
: ''
})
if (self.terminals) {
for (var i in self.terminals) {
console.log(self.terminals[i])
var icon = '/static/images/box_online.png'
if (self.terminals[i].online == 0) {
icon = '/static/images/box_offline.png'
} else if (self.terminals[i].useAll == 1) {
icon = '/static/images/box_full.png'
}
self.addMarker(
self.terminals[i],
new qq.maps.MarkerImage(
icon,
new qq.maps.Size(32, 32),
new qq.maps.Point(0, 0),
new qq.maps.Point(16, 32),
new qq.maps.Size(32, 32)
)
)
}
}


var opt = {
position: new qq.maps.LatLng(
self.myLocation.latitude,
self.myLocation.longitude
),
map: self.map
}
if (icon) {
opt.icon = new qq.maps.MarkerImage(
'/static/images/icons/i_start.png',
new qq.maps.Size(32, 32),
new qq.maps.Point(0, 0),
new qq.maps.Point(32, 32),
new qq.maps.Size(32, 32)
)

}
var marker = new qq.maps.Marker(opt)

self.isInit = true
},
getTerminalDetail() {
let self = this
getTerminalDetail({ data: { terminalId: self.sid } }).then(function(
data
) {
self.currentTerminal = data.Content
setTimeout(self.init, 500)
})
},
finishWorkOrder() {
let self = this
this.$vux.confirm.show({
title: '提醒您',
content: '确定已修复吗？',
onCancel() {},
onConfirm() {
self.times = 0
finishWorkOrder({ data: { orderId: self.orderId } }).then(function(
data
) {
self.$vux.toast.text('操作成功')
self.$router.push({
path: '/support'
})
})
}
})
},
initLocation() {
let self = this
self.$wechat.getLocation({
type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
fail: function(res) {
console.error(res)
},
success: function(res) {
var latitude = res.latitude 
var longitude = res.longitude 
var speed = res.speed 
var accuracy = res.accuracy 
setCookie('latitude', latitude)
setCookie('longitude', longitude)
self.myLocation = { latitude: latitude, longitude: longitude }
self.center = new qq.maps.LatLng(latitude, longitude)
self.init()
self.setCenter(self.center)



}
})
},
setCenter(_center) {
try {
this.map.panTo(_center)
} catch (e) {}
},
addMarker(terminal, icon) {
let self = this
var opt = {
position: terminal.gps,
map: self.map
}
if (icon) {
opt.icon = icon
}
var marker = new qq.maps.Marker(opt)












},

openDoor() {
let self = this
this.$vux.confirm.show({

title: '提醒您',
content: '确定打开回收箱的所有门？',
onCancel() {},
onConfirm() {
self.confirmOpenDoor()
}
})
},
confirmOpenDoor() {
let self = this
self.times = 0
self.$vux.loading.show({
text: '正在打开...'
})
openDoor({
data: {
terminalId: self.currentTerminal.sid,
latitude: self.myLocation.latitude,
longitude: self.myLocation.longitude
}
}).then(function(data) {
self.serialNumber = data.Content
setTimeout(self.refreshSerialNumber, 3000)
})
},
refreshSerialNumber() {
let self = this
self.times++
if (self.times > 15) {
self.$vux.loading.hide()
self.$vux.toast.text('开门指令超时未响应！')
return
}
getOpenDoorStatus({
data: {
terminalId: self.currentTerminal.terminalId,
serialNumber: self.serialNumber
}
}).then(
function(data) {
if (data.Message == '1') {
setTimeout(self.refreshSerialNumber, 2000)
} else {
self.$vux.loading.hide()
self.$vux.toast.text('门已打开')
}
},
function(data) {

}
)
},
routeTerminal() {
let self = this
self.$wechat.openLocation({
latitude: self.currentTerminal.latitude, // 纬度，浮点数，范围为90 ~ -90
longitude: self.currentTerminal.longitude, // 经度，浮点数，范围为180 ~ -180。
name: '回收箱位置', // 位置名
address: self.currentTerminal.location, // 地址详情说明
scale: 14, // 地图缩放级别,整形值,范围从1~28。默认为最大
infoUrl: '' 
})
},
openOrders(idx) {
let self = this
self.$router.push({
path: '/support/orderList',
query: { sid: self.sid, orderId: self.orderId }
})
}
},

data() {
return {
lineCount: 0,
myLocation: null,
center: {},
map: {},
directionsService: null,
directionsServiceList: [],
isInit: false,
dataSource: [],
terminals: [],
currentTerminal: { extInfo: {} },
isPopup: true,
listShow: true,
serialNumber: 0,
times: 0,
list: [],
sid: null,
orderId: null,
category: null
}
},
created() {},
mounted() {
let self = this
initWxJSSDK()
var longitude = getCookie('longitude')
var latitude = getCookie('latitude')
if (!latitude) {
latitude = 39.916527
}
if (!longitude) {
longitude = 116.397128
}
TMap('').then(qq => {
self.map = new qq.maps.Map(document.getElementById('map-container'), {

center: new qq.maps.LatLng(latitude, longitude),
zoom: 6,
disableDefaultUI: true
})


})
vue.wechat.ready(function(res) {
self.initLocation()
})

self.sid = self.$route.query.sid
self.orderId = self.$route.query.orderId
self.category = self.$route.query.category
console.log(self.sid)

self.getTerminalDetail()
}
}



// WEBPACK FOOTER //
// ./src/components/support/TerminalControl.vue